import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "Michael Clark",
        title: "Lead Designer",
        biography: "Michael Clark is an innovative lead designer with a keen eye for aesthetics and function. He has led numerous high-profile design projects, blending creativity with strategic vision. His work transforms ordinary spaces into inspiring environments. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum!",
        contacts: {
            phone: "222-333-4455",
            email: "michael.clark@example.com",
            address: "123 Design Lane, Suite 100, Cityville, ST 12345",
            website: "www.michaelclarkdesigns.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Interior Design Strategist",
            "Creative Director",
            "Residential Space Planner",
            "Commercial Design Consultant",
            "Lead Designer"
        ],
        skills: [
            { id: 1, title: "Interior Design", progress: 95 },
            { id: 2, title: "Concept Development", progress: 90 },
            { id: 3, title: "3D Visualization", progress: 88 },
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Sophia Anderson",
        title: "Interior Designer",
        biography: "Sophia Anderson is a talented interior designer recognized for her timeless style and functional approach to interiors. With a passion for creating harmonious spaces, she brings each client’s vision to life through thoughtful design and detail. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum!",
        contacts: {
            phone: "333-444-5566",
            email: "sophia.anderson@example.com",
            address: "123 Design Lane, Suite 100, Cityville, ST 12345",
            website: "www.sophiainteriors.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Residential Interior Expert",
            "Color & Material Consultant",
            "Space Optimization Specialist",
            "Interior Project Manager",
            "Interior Designer"
        ],
        skills: [
            { id: 1, title: "Space Planning", progress: 92 },
            { id: 2, title: "Color Theory", progress: 88 },
            { id: 3, title: "Client Collaboration", progress: 90 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Ethan Martin",
        title: "Architect",
        biography: "Ethan Martin is an accomplished architect known for his innovative structures and sustainable design practices. He integrates functionality with creativity, delivering architectural solutions that are both modern and enduring. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum!",
        contacts: {
            phone: "444-555-6677",
            email: "ethan.martin@example.com",
            address: "123 Design Lane, Suite 100, Cityville, ST 12345",
            website: "www.ethanmartinarchitects.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Sustainable Design Advocate",
            "Commercial Building Planner",
            "Urban Space Designer",
            "Project Architect",
            "Architect"
        ],
        skills: [
            { id: 1, title: "Architectural Design", progress: 94 },
            { id: 2, title: "Sustainable Planning", progress: 91 },
            { id: 3, title: "Blueprint Drafting", progress: 89 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Olivia Walker",
        title: "Design Consultant",
        biography: "Olivia Walker is a creative design consultant known for her keen eye for aesthetics and strategic approach to design solutions. She bridges the gap between client needs and practical implementation, ensuring every space is as functional as it is visually compelling. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum!",
        contacts: {
            phone: "555-666-7788",
            email: "olivia.walker@example.com",
            address: "123 Design Lane, Suite 100, Cityville, ST 12345",
            website: "www.oliviawalkerdesign.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Brand Identity Specialist",
            "Residential Design Advisor",
            "Visual Style Consultant",
            "Interior Branding Expert",
            "Design Consultant"
        ],
        skills: [
            { id: 1, title: "Client Communication", progress: 93 },
            { id: 2, title: "Concept Development", progress: 90 },
            { id: 3, title: "Design Strategy", progress: 87 }
        ]
    }

];

export default team;